'use client'
import { useTranslate } from '@repo/shared'
import { Col, Typography } from '@repo/ui/components'

export const HomeContainer = () => {
  const { t } = useTranslate()
  return (
    <Col className='w-full max-w-container-md mx-auto mb-8xl md:mb-0'>
      <Typography size='sm' weight='bold'>
        {t('agentsPage_title')}
      </Typography>
    </Col>
  )
}
